import {defineStore} from 'pinia';
import type {PointGPS} from '~/types/types';

export const useAdresseStore = defineStore('adresse', () => {
  const localisation = ref<PointGPS | null>(JSON.parse(localStorage.getItem('localisation') ?? 'null'));
  const adresse = ref<string | null>(localStorage.getItem('adresse'));

  watch(localisation, (newValue) => {
    if (newValue) localStorage.setItem('localisation', JSON.stringify(newValue));
    else localStorage.removeItem('localisation');
  });
  watch(adresse, (newValue) => {
    if (newValue) localStorage.setItem('adresse', newValue);
    else localStorage.removeItem('adresse');
  });

  function $reset() {
    localisation.value = null;
    adresse.value = null;
    localStorage.removeItem('localisation');
    localStorage.removeItem('adresse');
  }

  const setLocalisation = (data?: PointGPS) => (localisation.value = data);
  const setAdresse = (data?: string) => (adresse.value = data);

  const getLocalisation = () => localisation.value;
  const getAdresse = () => adresse.value;

  const isSearching = () => localisation.value !== null && adresse.value !== null;

  return {
    $reset,
    setLocalisation,
    setAdresse,
    getLocalisation,
    getAdresse,
    isSearching,
  };
});
